<ic-change-language />

<div>
	<ic-granny />

	<h1>{{ "error-page.title" | translate }}</h1>
	<p>
		{{ "error-page.description" | translate }}
	</p>
	<p>
		<span [innerHtml]="'error-page.contact_info' | translate"></span>
		@if (sentryId) {
			<span> {{ "error-page.smooth_handling" | translate }}</span>
		}
	</p>
	@if (sentryId) {
		<p>{{ "error-page.error-id" | translate: { sentryId: sentryId } }}</p>
	}

	<button data-test="granny-back-to-dashboard-button" (click)="redirectToDashboard()">
		{{ "error-page.redirect-button" | translate }}
	</button>
</div>
